export default __webpack_public_path__ + "static/media/hiw-1.8a2f712d.png";